import { instructorConceptDataActionTypes as types } from 'Screens';
import InitialState from 'store/InitialState';
import { IConceptData } from 'store/StateInterfaces';


export default function instructorConceptDataReducer(state = InitialState.instructorConceptDataMap, action) {
    switch (action.type) {
        case types.LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS:
            {
                const { conceptId, data } = action;
                let instructorConceptDataMap = new Map<number, IConceptData>(state);
                instructorConceptDataMap.set(conceptId, data);
                return instructorConceptDataMap;
            }
        case types.DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS:
            {

                const { conceptId, elemType, id } = action;
                let instructorConceptDataMap = new Map<number, IConceptData>(state);
                const data = { ...instructorConceptDataMap.get(conceptId) };
                const newPlaylist = data.playlist.filter((elem) => {
                    return (elem.type !== elemType || elem.content.id !== id);
                })

                const newData = {
                    ...data,
                    playlist: newPlaylist
                }
                instructorConceptDataMap.set(conceptId, newData);

                return instructorConceptDataMap;
            }

        case types.ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS:
            {

                const { conceptId, elemType, content } = action;
                let instructorConceptDataMap = new Map<number, IConceptData>(state);
                const data = { ...instructorConceptDataMap.get(conceptId) };
                let newPlaylist = data.playlist.map(e => ({ ...e }));
                newPlaylist.push({ type: elemType, content });

                const newData = {
                    ...data,
                    playlist: newPlaylist
                }
                instructorConceptDataMap.set(conceptId, newData);
                return instructorConceptDataMap;
            }
        case types.REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS:
            {
                const { conceptId, playlist } = action;
                let instructorConceptDataMap = new Map<number, IConceptData>(state);
                const data = { ...instructorConceptDataMap.get(conceptId) };

                const newData = {
                    ...data,
                    playlist
                }
                instructorConceptDataMap.set(conceptId, newData);

                return instructorConceptDataMap;
            }
        case types.INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS:
            {
                console.log('info')
                const { conceptId, title,description } = action;
                let instructorConceptDataMap = new Map<number, IConceptData>(state);
                const data = { ...instructorConceptDataMap.get(conceptId) };

                const newData = {
                    ...data,
                    title,
                    description
                }
                instructorConceptDataMap.set(conceptId, newData);

                return instructorConceptDataMap;
            }
        default:
            return state;
    }
} 